



















import { Component, Vue, Prop } from "vue-property-decorator";
import { FormBase, FormInput, FormPhone, FormTextarea, FormFile, FormError, FormSubmit } from "./parts";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { extend } from "vee-validate";

const phonePatterns = [
    /^\d{8,9}$/, // Belgium: 9 or 10 digits, starts with 0
    /^[1-9]\d{8}$/, // Netherlands: 10 digits, starts with 0 + non-zero digit
];

extend("phone_number", {
    validate(value: string) {
        if (!value) {
            return "Dit is geen geldig telefoonnummer.";
        }

        // Remove spaces, dots, and dashes
        value = value.replace(/[\s.-]/g, "");

        // Check if the number matches any of the country-specific patterns
        const isValid = phonePatterns.some(pattern => pattern.test(value));

        return isValid || "Dit is geen geldig telefoonnummer.";
    },
    message: "Dit is geen geldig telefoonnummer."
});

@Component({
    components: {
        FormBase,
        FormInput,
        FormPhone,
        FormTextarea,
        FormError,
        FormFile,
        FormSubmit
    }
})
export default class OfficeForm extends Vue {
    @Prop() contactEmail!: string;
    @Prop() officeTitle?: string;

    payload: any = {
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        office: "",
        message: "",
        files: []
    };

    errorResponse: ErrorResponse = {
        status: 0,
        errors: []
    };

    success_message = "";

    private submit(form: FormClass) {
        this.success_message = "";
        const formData = new FormData();
        formData.append("method", "_POST");
        if (this.contactEmail) {
            formData.append("contact_email", this.contactEmail);
        }
        formData.append("email", this.payload.email);
        formData.append("first_name", this.payload.first_name);
        formData.append("last_name", this.payload.last_name);
        formData.append("phone", this.payload.phone);
        formData.append("office", this.officeTitle ? this.officeTitle : '');
        formData.append("message", this.payload.message);
        Object.values(this.payload.files).forEach((file: any) => {
            formData.append("files[]", file);
        });

        // @ts-ignore
        axios
            .post(`/api/forms/office-form`, formData)
            .then((response: any) => {
                // @ts-ignore
                if (window.hasOwnProperty("dataLayer") && dataLayer) {
                    // @ts-ignore
                    dataLayer.push({
                        event: "formSubmission",
                        formId: "4",
                        response: [
                            { name: "first_name", value: this.payload.first_name },
                            { name: "last_name", value: this.payload.last_name },
                            { name: "email", value: this.payload.email },
                            { name: "phone", value: this.payload.phone },
                            { name: "message", value: this.payload.message },
                            { name: "href", value: window.location.href },
                            { name: "pathname", value: window.location.pathname }
                        ]
                    });
                }

                this.payload = {
                    email: "",
                    first_name: "",
                    last_name: "",
                    phone: "",
                    message: "",
                    files: []
                };
                this.success_message = "Je aanvraag werd goed ingediend.";
            })
            .catch((e: { response: { data: ErrorResponse } }) => {
                this.errorResponse = e.response.data;
            })
            .finally(() => {
                form.reset();
            });
    }
}
